// extracted by css-extract-rspack-plugin
export default {"content":"T_my8l_POh0nqaFO__content___"};